module.exports = __webpack_public_path__ + "static/media/iphone.0a3962f7.jpeg";